import { Field, Model, FIELD_TYPES } from "@/vue-ocom/schema";

export default Model("volunteer_shift", {
  verbose_name: "Volunteer Weekend Shift",
  verbose_name_plural: "Volunteer Weekend Shifts",
  fields: [
    Field("id", {
      label: "ID",
      primary_key: true,
      readonly: true,
      hide: false,
      field_type: FIELD_TYPES.AutoNumber,
    }),
    Field("shift_id", {
      label: "Shift ID",
      primary_key: false,
      readonly: false,
      hide: false,
      required: true,
      field_type: FIELD_TYPES.String,
      default: () => "",
    }),
    Field("day_of_week", {
      label: "Day",
      primary_key: false,
      readonly: false,
      hide: false,
      required: true,
      field_type: FIELD_TYPES.Number,
      default: () => 5,
    }),
    Field("shift_type", {
      label: "Shift Type",
      primary_key: false,
      readonly: false,
      hide: false,
      required: true,
      field_type: FIELD_TYPES.Number,
      default: () => 1,
    }),
    Field("depot", {
      label: "Depot",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "CodeDepot",
      ref_display_field: "description",
      default: () => null,
    }),
    Field("depot__description", {
      label: "Depot",
      primary_key: false,
      readonly: true,
      hide: false,
      field_type: FIELD_TYPES.String,
      default: () => null,
    }),
    Field("start_time", {
      label: "Start Time",
      primary_key: false,
      readonly: false,
      hide: false,
      required: true,
      field_type: FIELD_TYPES.String,
      default: () => "06:00:00",
    }),
    Field("end_time", {
      label: "End Time",
      primary_key: false,
      readonly: false,
      hide: false,
      required: true,
      field_type: FIELD_TYPES.String,
      default: () => "13:00:00",
    }),
    Field("active_start_date", {
      label: "Active From",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.DateTime,
      default: () => new Date(),
    }),
    Field("active_end_date", {
      label: "Active Until",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.DateTime,
      default: () => null,
    }),
  ],
});
